import { render, staticRenderFns } from "./SupiTableMenu.vue?vue&type=template&id=71a3a9b3&scoped=true&"
import script from "./SupiTableMenu.vue?vue&type=script&lang=js&"
export * from "./SupiTableMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a3a9b3",
  null
  
)

export default component.exports